import React from "react";
import Dropdown from "../../Dropdown";
import { Paper, List, ListItemIcon, ListItemText, ListItemButton } from "@mui/material";
import IconLayers from "@mui/icons-material/Layers";

const mapStyles = [
  { name: "Satellite", url: "mapbox://styles/mapbox/satellite-v9" },
  { name: "Map", url: "mapbox://styles/mapbox/outdoors-v11" },
  { name: "Light", url: "mapbox://styles/mapbox/light-v10" },
  { name: "Dark", url: "mapbox://styles/mapbox/dark-v10" },
];

function Toggle() {
  return (
    <ListItemButton>
      <ListItemIcon>
        <IconLayers />
      </ListItemIcon>
      <ListItemText>Map style</ListItemText>
    </ListItemButton>
  );
}

const Contents = React.forwardRef(({ mapStyle, mapStyleHandler }, ref) => (
  <Paper ref={ref}>
    <List open={true}>
      {mapStyles.map(d => (
        <ListItemButton
          key={d.name}
          onClick={() => mapStyleHandler(d.url)}
          selected={d.url === mapStyle}
        >
          {d.name}
        </ListItemButton>
      ))}
    </List>
  </Paper>
));

export default Dropdown(Toggle, Contents);
